import { apiService } from "@/_services";
/**
 * Get End Products for all companies
 * @param { object } companies initial company information
 */
export function getEndProducts(companies) {
  let prods = [];
  companies.forEach(function(comp) {
    comp["portfolios"].forEach(function(port) {
      prods = prods.concat(port["fk_id_end_product"]);
    });
  });
  let params = {
    method: "GET",
    endpoint: "end_products",
    query_params: {
      format: "json",
      products: { id: prods }
    }
  };
  return apiService.getAll(params);
}
